import { useAppDispatch } from "../../../../../../redux/hooks";
import CustomButton from "../../../../../../components/CustomButton";
import SvgIcon from "../../../../../../helpers/SvgIcon";
import { ScannedPackagesFromBinDataInterface } from "../../../../../../redux/interfaces/expedition.interface";
import {
  getUnscannedPackagesInVolume,
  postCreateTraceability,
} from "../../../../../../redux/api/expedition.api";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../../helpers/apiHelper";
import useRoutesHelper from "../../../../../../hooks/useRoutesHelper";

function NonConformingPackagesActionButtons({
  crudData,
  tableContext,
}: {
  itemId: string;
  crudData: ScannedPackagesFromBinDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();

  const { withProblems } = routeParams;

  const { nr_volum, id_doctrans_detl, id_doctrans } = crudData;

  const handleCreateTraceability = async () => {
    const resultAction = await dispatch(
      postCreateTraceability({
        id_doctrans_detl: id_doctrans_detl,
        nr_volum: nr_volum,
        id_doctrans: id_doctrans,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postCreateTraceability) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        getUnscannedPackagesInVolume({
          page: tableContext.tablePagination.page,
          per_page: tableContext.tablePagination.rowsPerPage,
          nrVolum: nr_volum,
        }),
      );
    }
  };

  return (
    <>
      {withProblems === "notScanned" && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          tooltipTitle="Creeaza trasabilitate"
          withConfirmationModal={{
            modalTitle: "Creeaza trasabilitate",
            modalSubtitle: `Doriti sa creati trasabilitate pentru coletul cu nr. expeditie ${crudData.doc_trans}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleCreateTraceability,
          }}>
          <SvgIcon type="NONCONFORMING" fill="white" />
        </CustomButton>
      )}
    </>
  );
}

export default NonConformingPackagesActionButtons;
